module.exports = __webpack_public_path__ + "img/enterprise-main11.8b01dc23.jpg";